const EditInternationalApply = () => import('../modules/xmsb/energy/operators/EditInternationalApplyGzl')

export default [
  {

    path: '/internationalapplyedit',
    name: 'internationalapplyedit',
    component: EditInternationalApply,
    meta: {
      title: '2019年市级商务发展专项资金 - 申报开拓国际市场资金项目',
      fullscreen: true,
    },
  },
]
